module.exports = __webpack_public_path__ + "img/invite_friends.6942538d.svg";